import React from 'react'

const TypeReport = (props) => {
    const { returnPageHeihgt, FilterHeight, totalItemQuantity, sortItemQuantity, sortBy, handleSortItemQuantity, handleSortCaseQuantity,
        totalCaseQuantity, sortCaseQuantity, showPercentIssue, baseLink, linkTo, itemQuantity, caseQuantity, issueTypes
    } = props

    const issueTypeBySort = React.useMemo(() => {
        if (sortBy === 'item') {
            if (sortItemQuantity) {
                return issueTypes.sort((a, b) => a.itemQuantity - b.itemQuantity)
            } else {
                return issueTypes.sort((a, b) => b.itemQuantity - a.itemQuantity)
            }
        } else {
            if (sortCaseQuantity) {
                return issueTypes.sort((a, b) => a.caseQuantity - b.caseQuantity)
            } else {
                return issueTypes.sort((a, b) => b.caseQuantity - a.caseQuantity)
            }
        }
    }, [sortItemQuantity, sortCaseQuantity, issueTypes, sortBy])

    return (
        <>
            <table className="table PackageIssueReportTable" style={{ top: `${returnPageHeihgt + FilterHeight}px` }}>
                <thead >
                    <tr>
                        <th className="col-confirm" rowSpan={2}>Kết quả duyệt</th>
                        <th className="col-type" rowSpan={2}>Loại lỗi</th>
                        <th className="col-item-quantity">Lượng đơn lỗi</th>
                    </tr>
                    <tr>
                        <th className="col-item-quantity text-right">
                            {totalItemQuantity} {
                                sortItemQuantity ? <i className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === 'item' && 'text-primary'}`} onClick={handleSortItemQuantity} /> :
                                    <i className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === 'item' && 'text-primary'}`} onClick={handleSortItemQuantity} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !!issueTypeBySort.length && issueTypeBySort.map((item, index) => (
                            <tr key={item._id}>
                                {index === 0 && <td className="col-confirm" rowSpan={issueTypeBySort.length}>Approve AND 50/50</td>}
                                <td className="col-type">{item.name || 0}</td>
                                <td className="col-item-quantity text-right">{showPercentIssue(item.itemQuantity, totalItemQuantity)}</td>
                            </tr>
                        ))
                    }
                    <tr>
                        <td className="col-confirm">Reject</td>
                        <td className="col-type">-</td>
                        <td className="col-item-quantity text-right">{showPercentIssue(itemQuantity, totalItemQuantity)}</td>
                    </tr>

                    {
                        issueTypeBySort.length === 0 &&
                        <tr>
                            <td colSpan={6}>
                                <p className="text-center text-muted mb-0">
                                    No data
                                </p>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>

            <table className="table PackageIssueReportTable" id="Issue_Type_Report" style={{ top: `${returnPageHeihgt + FilterHeight}px`, display: 'none' }}>
                <thead style={{ display: 'none' }}>
                    <tr>
                        <th className="col-confirm" rowSpan={2}>Kết quả duyệt</th>
                        <th className="col-type" rowSpan={2}>Loại lỗi</th>
                        <th className="col-item-quantity">Lượng đơn lỗi</th>
                    </tr>
                    <tr>
                        <th className="col-item-quantity text-right">
                            {totalItemQuantity} {
                                sortItemQuantity ? <i className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === 'item' && 'text-primary'}`} onClick={handleSortItemQuantity} /> :
                                    <i className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === 'item' && 'text-primary'}`} onClick={handleSortItemQuantity} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody style={{ display: 'none' }}>
                    {
                        !!issueTypeBySort && issueTypeBySort.map((item, index) => (
                            <tr key={item._id}>
                                {index === 0 && <td className="col-confirm" rowSpan={issueTypeBySort.length}>Approve AND 50/50</td>}
                                <td className="col-type">{item.name || 0}</td>
                                <td className="col-item-quantity text-right">{showPercentIssue(item.itemQuantity, totalItemQuantity)}</td>
                            </tr>
                        ))
                    }
                    <tr>
                        <td className="col-confirm">Reject</td>
                        <td className="col-type">-</td>
                        <td className="col-item-quantity text-right">{showPercentIssue(itemQuantity, totalItemQuantity)}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default TypeReport